export default "__VITE_ASSET__sDOb9Pbk__"